module.exports = __webpack_public_path__ + "static/media/equalizer.cd3bb57a.svg";